<template>
  <div class="relative mb-8 grid gap-2 bg-neutral-50 p-6 text-center">
    <KikHeading
      :level="6"
      title="Can we help you?"
      description="Write us"
      class="text-center"
    >
      <template #description="{ description }">
        <div class="mt-2 text-xs font-light leading-4 text-neutral-500">
          {{ $t(description) }}
          <SfLink
            variant="secondary"
            data-testid="link__contact_via_email"
            :href="`mailto:${$t('contactViaEmail')}`"
          >
            {{ $t('Contact via email') }}
          </SfLink>
        </div>
      </template>
    </KikHeading>
  </div>
</template>

<script lang="ts" setup>
import { SfLink } from '@storefront-ui/vue';
</script>
